import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=05e54032"
import script from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=05e54032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports